class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
    this.closeTimeout = null;

    this.addEventListener('mouseenter', this.onMenuMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMenuMouseLeave.bind(this));
    this.querySelectorAll('details').forEach((details) => {
      details.addEventListener('mouseenter', this.onDetailsMouseEnter.bind(this));
      details.querySelector('summary').addEventListener('click', this.onSummaryClick.bind(this));
    });
  }

  isDesktop() {
    return this.desktopMediaQuery.matches;
  }

  onMenuMouseEnter() {
    if (!this.isDesktop()) return;
    this.cancelClose();
    this.openDetails(this.mainDetailsToggle);
  }

  onMenuMouseLeave() {
    if (!this.isDesktop()) return;
    this.scheduleClose();
  }

  onDetailsMouseEnter(event) {
    if (!this.isDesktop()) return;
    this.cancelClose();
    this.openDetails(event.currentTarget);
  }

  onSummaryClick(event) {
    if (!this.isDesktop()) return;
    event.preventDefault();
    this.openDetails(event.currentTarget.closest('details'));
  }

  openDetails(details) {
    details.setAttribute('open', '');
    details.querySelector('summary').setAttribute('aria-expanded', true);
  }

  scheduleClose() {
    this.cancelClose();
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 250);
  }

  cancelClose() {
    if (!this.closeTimeout) return;
    clearTimeout(this.closeTimeout);
    this.closeTimeout = null;
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    this.cancelClose();
    this.querySelectorAll('details[open]').forEach((details) => {
      details.removeAttribute('open');
      details.querySelector('summary').setAttribute('aria-expanded', false);
    });
  }
}

customElements.define('header-menu', HeaderMenu);